/* eslint-disable curly */
import React, { Component, useRef, useState, useEffect } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  Alert,
  ImageBackground,
  Platform,
} from "react-native";
import { EventRegister } from "react-native-event-listeners";
import Icon from "react-native-vector-icons/FontAwesome";

import styles from "./styles";
import ButtonConfirm from "../../components/ButtonConfirm";
import Loading from "../../components/Loading";
import {
  adicionarTelefone,
  enviarCodigoSMS,
} from "../../services/aluno-service";
import { getAluno } from "../../services/aluno-service";
import { onSignOut } from "../../services/auth-service";
import { StackActions, NavigationActions } from "react-navigation";
import { alert } from "../../utils/alerts";

const SemTelefoneVerificado = ({ navigation }) => {
  const [loading, setLoading] = useState(false);
  const [celulares, setCelulares] = useState([]);

  useEffect(() => {
    const listener = EventRegister.addEventListener(
      "SemTelefoneVerificado",
      async (data) => {
        carregarAluno(true);
      }
    );

    carregarAluno(false);

    return () => {
      EventRegister.removeEventListener(listener);
    };
  }, []);

  const temWhatsapp = async (telefone) => {
    if (Platform.OS === "web")
      if (window.confirm("Você tem Whatsapp nesse número?")) {
        verificarNumero(telefone, true);
      } else {
        verificarNumero(telefone, false);
      }
    else
      return (
        Alert.alert("Whatsapp?", "Você tem Whatsapp nesse número?", [
          {
            text: "Sim",
            onPress: () => {
              verificarNumero(telefone, true);
            },
          },
          {
            text: "Não",
            onPress: () => {
              verificarNumero(telefone, false);
            },
          },
        ])
      );
  };

  const verificarNumero = async (telefone, whatsapp) => {
    setLoading(true);
    const response = await enviarCodigoSMS(telefone.id, whatsapp);

    if (!response.ok) {
      let { erro } = await response.json();
      setLoading(false);
      return alert("Ops...", erro);
    }

    setLoading(false);
    navigation.push("VerificarCodigoSMS", {
      telefoneId: telefone.id,
      whatsapp,
      fromSemTelefone: true,
    });
  };

  const carregarAluno = async (refresh) => {
    const aluno = await getAluno(refresh);

    const filtro = aluno.telefones.filter((t) => (t.tipo === "C" ? t : null));

    setCelulares(filtro);
  };

  return (
    <ImageBackground
      source={require("../../../resources/imgs/bg.jpg")}
      style={styles.container}
      imageStyle={styles.imageContainer}
    >
      {loading && <Loading />}
      <View style={[styles.containerForm]}>
        <ScrollView style={{ flex: 1, width: "100%", paddingTop: 20 }}>
          <Text style={styles.textHeader1}>
            Queremos sempre manter contato com você!
          </Text>

          <Text style={styles.textHeader2}>
            Por isso precisamos validar o seu número de celular.
          </Text>

          {celulares.length > 0 && (
            <>
              <Text style={styles.textHeader2}>
                Vi que você já tem
                {celulares.length > 1
                  ? " alguns números cadastrados "
                  : " um número cadastrado "}
                aqui. Toque em um deles para prosseguir...
              </Text>
              {celulares.map((c) => (
                <TouchableOpacity
                  key={c.id}
                  onPress={() => {
                    temWhatsapp(c);
                  }}
                >
                  <View
                    style={[
                      styles.dataContainer,
                      { alignItems: "center", alignSelf: "center" },
                    ]}
                  >
                    <Text style={styles.textCelular}>
                      ({c.ddd}) XXXXX-{c.numero.substring(5, 9)}
                    </Text>
                  </View>
                </TouchableOpacity>
              ))}
              <Text style={[styles.textHeader2, { marginTop: 20 }]}>
                Ou então...
              </Text>
            </>
          )}
          <TouchableOpacity
            onPress={() => {
              navigation.push("AdicionarCelular", { fromSemTelefone: true });
            }}
          >
            <Text style={[styles.link, { alignSelf: "center", marginTop: 20 }]}>
              Cadastrar novo número
            </Text>
          </TouchableOpacity>
        </ScrollView>
      </View>
    </ImageBackground>
  );
};

SemTelefoneVerificado.navigationOptions = ({ navigation }) => {
  return {
    headerStyle: {
      backgroundColor: "#0F0F0F",
    },
    headerTitleStyle: {
      color: "#FFF",
    },
    headerShown: true,
    headerRight: () => (
      <TouchableOpacity
        onPress={() => {
          onSignOut();
          const navigateAction = StackActions.reset({
            index: 0,
            actions: [NavigationActions.navigate({ routeName: "SignedOut" })],
          });
          navigation.dispatch(navigateAction);
        }}
      >
        <Icon
          style={{ marginEnd: 5 }}
          name="sign-out"
          size={30}
          color="#F1F1F1"
        />
      </TouchableOpacity>
    ),
  };
};

export default SemTelefoneVerificado;
